// extracted by mini-css-extract-plugin
export var chip = "_4w-0";
export var filterDropdown = "_4w-5";
export var filterItem = "_4w-6";
export var icon = "_4w-1";
export var removeButton = "_4w-3";
export var removeIcon = "_4w-4";
export var separator = "_4w-2";